// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item.user-item {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 999;
  border-radius: var(--border-radius-large);
  --padding-start: var(--spacing-small);
  --padding-end: var(--spacing-small);
  --inner-padding-end: 0;
}

ion-item.user-item ion-buttons {
  height: 100%;
}

ion-item.user-item ion-buttons ion-menu-button {
  height: 100%;
}

ion-item.user-item ion-label {
  margin: 0;
  padding-left: var(--spacing-small);
  padding-top: var(--spacing-xx-small);
  padding-bottom: var(--spacing-xx-small);
  padding-right: var(--spacing-small);
}
ion-item.user-item ion-label p {
  font-size: var(--font-size-xx-small);
  font-style: italic;
  line-height: 0.9rem;
}

.home-icon {
  margin-right: var(--spacing-small);
  margin-left: var(--spacing-small);
  font-size: var(--icon-size-small);
  cursor: pointer;
}

.menu-buttons {
  margin: 0;
}

ion-menu-button {
  --padding-start: var(--spacing-small);
  --padding-end: var(--spacing-small);
}

.menuIcon {
  width: var(--icon-size-large);
  height: var(--icon-size-large);
  max-width: var(--icon-size-large);
  transition: all 0.2s ease;
  padding: 2px;
}

.menuIcon:hover {
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
  transform: scale(1.1);
  filter: brightness(1.8);
  cursor: pointer;
  border-radius: var(--border-radius-medium);
}

/** Media queries to set font size and spacing based on screen size **/
/*#region Small Screens*/
/* Styles for screens smaller than 800px wide or 550 high */
@media (max-width: 800px) or (max-height: 550px) {
  ion-item.user-item {
    --min-height: 32px;
    height: 32px;
    width: auto;
  }
  ion-item.user-item::part(native) {
    min-height: 32px;
    height: 32px;
  }
  .home-icon {
    margin-left: var(--spacing-medium);
  }
  ion-menu-button {
    --padding-start: 0px;
    --padding-end: 0px;
  }
}
/*#endregion Small Screens*/
/*#region Medium Screens*/
/* Styles for medium screens with min with of 800px and min height of 550px */
@media (min-width: 800px) and (min-height: 550px) {
  ion-item.user-item {
    --min-height: 40px;
    height: 40px;
    width: auto;
  }
  ion-item.user-item::part(native) {
    min-height: 40px;
    height: 40px;
  }
  .home-icon {
    margin-left: var(--spacing-medium);
  }
  ion-menu-button {
    --padding-start: 0px;
    --padding-end: 0px;
  }
}
/*#endregion Medium Screens*/
/*#region Larger Screens*/
/* Styles for screens larger than 1000px wide and 600px high */
@media (min-width: 1000px) and (min-height: 600px) {
  .user-item {
    width: -moz-fit-content;
    width: fit-content;
    min-width: 250px;
    max-width: 280px;
    --min-height: 50px;
  }
  ion-item.user-item {
    --min-height: 50px;
    height: auto;
    width: auto;
  }
  ion-item.user-item::part(native) {
    min-height: 50px;
    height: auto;
  }
}
/*#endregion Larger Screens*/`, "",{"version":3,"sources":["webpack://./src/app/components/user-menu/user-menu.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,yCAAA;EACA,qCAAA;EACA,mCAAA;EACA,sBAAA;AACF;;AACA;EACE,YAAA;AAEF;;AAAA;EACE,YAAA;AAGF;;AAAA;EACE,SAAA;EACA,kCAAA;EACA,oCAAA;EACA,uCAAA;EACA,mCAAA;AAGF;AAFE;EACE,oCAAA;EACA,kBAAA;EACA,mBAAA;AAIJ;;AAAA;EACE,kCAAA;EACA,iCAAA;EACA,iCAAA;EACA,eAAA;AAGF;;AAAA;EACE,SAAA;AAGF;;AAAA;EACE,qCAAA;EACA,mCAAA;AAGF;;AAAA;EACE,6BAAA;EACA,8BAAA;EACA,iCAAA;EACA,yBAAA;EACA,YAAA;AAGF;;AAAA;EACE,sCAAA;EACA,qBAAA;EACA,uBAAA;EACA,eAAA;EACA,0CAAA;AAGF;;AAAA,sEAAA;AAEA,wBAAA;AAEE,2DAAA;AACA;EACE;IACE,kBAAA;IACA,YAAA;IACA,WAAA;EACJ;EAAI;IACE,gBAAA;IACA,YAAA;EAEN;EAEE;IACE,kCAAA;EAAJ;EAGE;IACE,oBAAA;IACA,kBAAA;EADJ;AACF;AAKA,2BAAA;AAEA,yBAAA;AAEE,6EAAA;AACA;EACE;IACE,kBAAA;IACA,YAAA;IACA,WAAA;EALJ;EAMI;IACE,gBAAA;IACA,YAAA;EAJN;EAQE;IACE,kCAAA;EANJ;EASE;IACE,oBAAA;IACA,kBAAA;EAPJ;AACF;AASA,4BAAA;AAEA,yBAAA;AAEE,8DAAA;AACA;EACE;IACE,uBAAA;IAAA,kBAAA;IACA,gBAAA;IACA,gBAAA;IACA,kBAAA;EATJ;EAYE;IACE,kBAAA;IACA,YAAA;IACA,WAAA;EAVJ;EAWI;IACE,gBAAA;IACA,YAAA;EATN;AACF;AAYA,4BAAA","sourcesContent":["ion-item.user-item {\r\n  position: fixed;\r\n  right: 20px;\r\n  bottom: 20px;\r\n  z-index: 999;\r\n  border-radius: var(--border-radius-large);\r\n  --padding-start: var(--spacing-small);\r\n  --padding-end: var(--spacing-small);\r\n  --inner-padding-end: 0;\r\n}\r\nion-item.user-item ion-buttons {\r\n  height: 100%;\r\n}\r\nion-item.user-item ion-buttons ion-menu-button {\r\n  height: 100%;\r\n}\r\n\r\nion-item.user-item ion-label {\r\n  margin: 0;\r\n  padding-left: var(--spacing-small);\r\n  padding-top: var(--spacing-xx-small);\r\n  padding-bottom: var(--spacing-xx-small);\r\n  padding-right: var(--spacing-small);\r\n  p {\r\n    font-size: var(--font-size-xx-small);\r\n    font-style: italic;\r\n    line-height: 0.9rem;\r\n  }\r\n}\r\n\r\n.home-icon {\r\n  margin-right: var(--spacing-small);\r\n  margin-left: var(--spacing-small);\r\n  font-size: var(--icon-size-small);\r\n  cursor: pointer;\r\n}\r\n\r\n.menu-buttons {\r\n  margin: 0;\r\n}\r\n\r\nion-menu-button {\r\n  --padding-start: var(--spacing-small);\r\n  --padding-end: var(--spacing-small);\r\n}\r\n\r\n.menuIcon {\r\n  width: var(--icon-size-large);\r\n  height: var(--icon-size-large);\r\n  max-width: var(--icon-size-large);\r\n  transition: all 0.2s ease;\r\n  padding: 2px;\r\n}\r\n\r\n.menuIcon:hover {\r\n  box-shadow: 0 0 4px rgba(0,0,0,0.3);\r\n  transform: scale(1.1);\r\n  filter: brightness(1.8);\r\n  cursor: pointer;\r\n  border-radius: var(--border-radius-medium);\r\n}\r\n\r\n/** Media queries to set font size and spacing based on screen size **/\r\n\r\n/*#region Small Screens*/\r\n\r\n  /* Styles for screens smaller than 800px wide or 550 high */\r\n  @media (max-width: 800px) or (max-height: 550px) {\r\n    ion-item.user-item {\r\n      --min-height: 32px;\r\n      height: 32px;\r\n      width: auto;\r\n      &::part(native) {\r\n        min-height: 32px;\r\n        height: 32px;\r\n      }\r\n    }\r\n\r\n    .home-icon {\r\n      margin-left: var(--spacing-medium);\r\n    }\r\n\r\n    ion-menu-button {\r\n      --padding-start: 0px;\r\n      --padding-end: 0px;\r\n    }\r\n\r\n  }\r\n\r\n/*#endregion Small Screens*/\r\n\r\n/*#region Medium Screens*/\r\n\r\n  /* Styles for medium screens with min with of 800px and min height of 550px */\r\n  @media (min-width: 800px) and (min-height: 550px) {\r\n    ion-item.user-item {\r\n      --min-height: 40px;\r\n      height: 40px;\r\n      width: auto;\r\n      &::part(native) {\r\n        min-height: 40px;\r\n        height: 40px;\r\n      }\r\n    }\r\n\r\n    .home-icon {\r\n      margin-left: var(--spacing-medium);\r\n    }\r\n\r\n    ion-menu-button {\r\n      --padding-start: 0px;\r\n      --padding-end: 0px;\r\n    }\r\n  }\r\n/*#endregion Medium Screens*/\r\n\r\n/*#region Larger Screens*/\r\n\r\n  /* Styles for screens larger than 1000px wide and 600px high */\r\n  @media (min-width: 1000px) and (min-height: 600px) {\r\n    .user-item {\r\n      width: fit-content;\r\n      min-width: 250px;\r\n      max-width: 280px;\r\n      --min-height: 50px;\r\n    }\r\n\r\n    ion-item.user-item {\r\n      --min-height: 50px;\r\n      height: auto;\r\n      width: auto;\r\n      &::part(native) {\r\n        min-height: 50px;\r\n        height: auto;\r\n      }\r\n    }\r\n  }\r\n/*#endregion Larger Screens*/\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
